export const CUSTOM_EVENTS = {
  // Live Requests alert event
  REQUEST_ALERT_EVENT: "LiveRequests-AlertEvent",
};
